module.exports = __webpack_public_path__ + "static/media/docker.dfac349e.png";